import { Pipe, PipeTransform } from '@angular/core';
import { StanoviskoDetailDto } from '@generated/be';

@Pipe({
  name: 'stanovisko',
  standalone: true,
})
export class StanoviskoPipe implements PipeTransform {
  transform(stanovisko: StanoviskoDetailDto) {
    if (!stanovisko) return '';
    if (stanovisko.souhlasne === true) {
      return 'Souhlasné stanovisko';
    } else if (stanovisko.posledniUzivatel) {
      return 'Nesouhlasné stanovisko';
    } else {
      return 'Stanovisko nebylo poskytnuto';
    }
  }
}
